<template>

  <page-tabs
      :tabs="tabs"
  >
    <template v-slot:default="{tabSelected}">
          <Services v-if="tabSelected==='Services'"/>
          <NomenCats v-if="tabSelected==='NomenCats'"/>
          <DirectionCats v-if="tabSelected==='DirectionCats'"/>
          <PriceHistory v-if="tabSelected==='PriceHistory'"/>
    </template>
  </page-tabs>
 
</template>

<script>
import PageTabs from "@/componentsV2/base/PageTabs.vue";
import Services from "@/views/Service/Services.vue";
import NomenCats from "@/views/Price/NomenCats.vue";
import DirectionCats from "@/views/Price/DirectionCats.vue";
import PriceHistory from "@/views/Price/PriceHistory.vue";

export default {
  components: {PageTabs,DirectionCats, NomenCats, Services, PriceHistory},
  data: () => ({
    tabs:[
      { 
        name: 'Services', 
        perm: 'servicesService', 
        label: 'Услуги', 
      },
      { 
        name: 'NomenCats', 
        perm: 'servicesNomen', 
        label: 'Номенклатура', 
      },
      { 
        name: 'DirectionCats', 
        perm: 'servicesDirection', 
        label: 'Направления', 
      },
      { 
        name: 'PriceHistory', 
        perm: 'servicesHistory', 
        label: 'История', 
      },
    ],
  })
}
</script>